import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Editor } from '@quicktools/shared-components/components/domainSpecific/text/Editor';
import useEditorData from '@quicktools/shared-components/hooks/useEditorData';
import useSnackbarStore from '@quicktools/shared-components/hooks/snackbar';

import analytics from '../../services/analytics';
import { Braze } from '../../services/braze';
import useStore from '../../store/emojis-store';

import useStyles from './styles';

export default function EmojisEditor() {
  const styles = useStyles();
  const { t } = useTranslation();
  const editorExpanded = useStore((state) => state.editorExpanded);
  const setEditorExpanded = useStore((state) => state.setEditorExpanded);
  const editorData = useStore((state) => state.editorData);
  const setEditorData = useStore((state) => state.setEditorData);
  const snackbarShowWarning = useSnackbarStore((state) => state.snackbarShowWarning);
  const onCopyError = useCallback(() => snackbarShowWarning(t('error.clipboardCopy')), []);
  useEditorData(setEditorData, setEditorExpanded);

  return (
    <Editor
      analytics={analytics}
      className={styles.root}
      defaultText="Copy a font, emoji, or symbol above or write/paste here to get started..."
      heading="Editor"
      data={editorData}
      setData={setEditorData}
      onCopyClick={() => {
        analytics.emojiArrayCopy();
        Braze.event('emoji_array_copy');
      }}
      onCopyError={onCopyError}
      onCloseClick={() => analytics.emojiArrayClear()}
      expanded={editorExpanded}
      onExpand={setEditorExpanded}
    />
  );
}
